"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var exterior = {
    EXTERIOR: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fragment Exterior on Exterior {\n      code @include(if: $dataLayer)\n      categoryCode @include(if: $dataLayer)\n      shortname\n      attributes {\n        oemcode\n      }\n      price {\n        ...Price\n      }\n    }\n  "], ["\n    fragment Exterior on Exterior {\n      code @include(if: $dataLayer)\n      categoryCode @include(if: $dataLayer)\n      shortname\n      attributes {\n        oemcode\n      }\n      price {\n        ...Price\n      }\n    }\n  "]))),
};
exports.default = exterior;
var templateObject_1;
